import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

const FAQS = [
    {
        q: "Which grades and countries do you support?",
        a: "YNova Education supports learners in Grades 1–6 (or the equivalent school year), with families in South Africa, the United Kingdom and the United States.",
    },
    {
        q: "Are lessons aligned with my child's school curriculum?",
        a: "Lessons are personalised to your child's grade and school curriculum — CAPS in South Africa, the relevant school year and curriculum in the UK, or relevant state or school standards in the US — using British or American English conventions as appropriate. YNova Education is an independent tutoring service and does not claim official accreditation.",
    },
    {
        q: "How much does a lesson cost?",
        a: "Please contact us to discuss lesson arrangements and availability.",
    },
    {
        q: "How do online lessons work?",
        a: "Lessons are planned to take place online. The platform, schedule and any materials needed will be confirmed before lessons begin.",
    },
    {
        q: "Is the introductory consultation free?",
        a: "Yes. YNova Education plans to offer a free introductory consultation so parents can discuss their child’s needs before deciding whether to proceed.",
    },
];

export const Faq = () => (
    <section id="faq" className="mx-auto max-w-4xl scroll-mt-24 px-6 py-20 lg:py-28" data-testid="faq-section">
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
        >
            <p className="text-xs font-bold tracking-widest text-sun uppercase">Frequently asked questions</p>
            <h2 className="font-heading mt-3 text-3xl font-extrabold tracking-tight text-ink sm:text-4xl">
                Good to know
            </h2>
        </motion.div>
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
        >
            <Accordion type="single" collapsible className="mt-10">
                {FAQS.map((faq, i) => (
                    <AccordionItem
                        key={faq.q}
                        value={`item-${i}`}
                        data-testid={`faq-item-${i + 1}`}
                        className="mb-4 rounded-2xl border border-ground-line/70 bg-ground-soft/50 px-6 data-[state=open]:border-sun/50"
                    >
                        <AccordionTrigger className="font-heading text-left text-base font-bold text-ink hover:text-sun hover:no-underline" data-testid={`faq-trigger-${i + 1}`}>
                            {faq.q}
                        </AccordionTrigger>
                        <AccordionContent className="text-sm leading-relaxed text-mist" data-testid={`faq-content-${i + 1}`}>
                            {faq.a}
                        </AccordionContent>
                    </AccordionItem>
                ))}
            </Accordion>
        </motion.div>
    </section>
);
